import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { PreviewCreativeModalOptions } from '@features/campaigns/builder/components/FormFields/FieldTypes.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './PreviewVideoWrapper.module.scss';

interface PreviewTVSimpleWrapperProps {
  fileUrl: string;
  editablePreview?: boolean;
  options?: PreviewCreativeModalOptions;
}
export function PreviewVideoWrapper({ fileUrl, editablePreview, options }: PreviewTVSimpleWrapperProps) {
  const { t } = useTranslation([i18nNameSpace.CAMPAIGNS]);
  const rejectTranslationKey = options ? options.rejectTranslationKey : 'builder.modals.deleteCreative';

  return (
    <div className={styles.container}>
      <div className={styles.creativePreviewBox}>
        <video preload='metadata' controls src={fileUrl} className={styles.creativeVideo} />
      </div>
      {editablePreview && (
        <div className={styles.footer}>
          <Button
            data-testid='tv-preview-reject-cta-button'
            className={styles.editButton}
            icon='pi pi-trash'
            onClick={options?.rejectImageCallback}
            text
            severity='danger'
            type='button'
          >
            {t(rejectTranslationKey)}
          </Button>
          <Button
            data-testid='tv-preview-accept-cta-button'
            className={styles.deleteButton}
            onClick={options?.acceptImageCallback}
            type='button'
          >
            {t('builder.modals.ok')}
          </Button>
        </div>
      )}
    </div>
  );
}
